import { useEffect, useRef, useState } from 'react'

export const useStickyClass = (offset = 0) => {
  const ref = useRef<HTMLElement | null>(null)
  const [isStuck, setIsStuck] = useState(false)

  useEffect(() => {
    function onScroll() {
      if (!ref.current) return

      const { top } = ref.current.getBoundingClientRect()

      setIsStuck(top <= offset)
    }

    window.addEventListener('scroll', onScroll)
    onScroll()

    return () => window.removeEventListener('scroll', onScroll)
  }, [offset])

  return { ref, isStuck }
}
